import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { UserService } from "../../../apis/networkdashboard/rest/services";
import { AuthService } from "../../../services/authservice";
import { BaseProblem, DialogReportProblemComponent } from "../dialog-report-problem/dialog-report-problem";

@Component({
  selector: "dialog-send-diagnostics",
  templateUrl: "./dialog-send-diagnostics.html",
  styleUrls: [
    "../dialog-domain-add/dialog-domain-add.scss",
    "../dialog-domain-add/options/domain-option-available/domain-option-available.scss",
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, AngularSvgIconModule, DialogReportProblemComponent],
})
export class DialogSendDiagnosticsComponent {
  private readonly user = inject(UserService);
  private readonly auth = inject(AuthService);
  protected isResultState = signal(false);
  protected isErrorState = signal(false);

  protected submit(base: BaseProblem) {
    this.user
      .reportDiagnostics({ body: base, customer_id: this.auth.viewingCustomer().customerId })
      .then(() => {
        this.isErrorState.set(false);
      })
      .catch(() => {
        this.isErrorState.set(true);
      })
      .finally(() => {
        this.isResultState.set(true);
      });
  }
}
